module.exports = __webpack_public_path__ + "4f7c4bbf135a06fef7ddbab278c8e739.woff";